import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '../../services/role.service';
import { CustomersService } from '../services/customers.service';
import { MatTableGeneratorComponent } from '../../shared/mat-table-generator/mat-table-generator.component';
import { MultiCrudDataSource } from '../../table-datasouces/multi-crud.datasource';
import { SofortTransactionsService } from '../services/sofort-transactions.service';
import { SofortTransaction } from '../../dto/sofort-transaction';
import { SofortStatementsService } from '../services/sofort-statements.service';
import { Sofort } from '../../dto/sofort';
import { FileHelper } from '../../helpers/file-helper';
import { toDateString, toDateTimeString } from '../../providers/app-date-adapter';
import { DateTableFilter } from '../../table-datasouces/date-table-filter';
import { SofortsService } from '../services/soforts.service';


@Component( {
  selector: 'app-soforts',
  templateUrl: './soforts.component.html',
  styleUrls: [ './soforts.component.css' ],
} )
export class SofortsComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private sofortTransactionsService: SofortTransactionsService,
    private sofortStatementsService: SofortStatementsService,
    private changeDetectorRefs: ChangeDetectorRef,
    private sofortsService: SofortsService
  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  ngOnInit() {
    this.table.filters.str = this.route.snapshot.queryParamMap.get( 'search' );  
}

  dataSource = new MultiCrudDataSource( this.sofortsService );

  getRowClass = ( item: Sofort ): string => {
    if ( !item.transactionAmount || !item.statementAmount ) {
return 'attention-row';
}
    return item.transactionAmount != item.statementAmount ? 'warning-row' : '';
  };

  columns = [
    { columnDef: 'transactionCardNumber',   header: 'Customer ID (card)'            , cell: ( row: Sofort ) => `${ row.transactionCardNumber || ''                  }` },
    { columnDef: 'transactionId',           header: 'Transaction ID'                , cell: ( row: Sofort ) => `${ row.transactionId || ''                          }` },
    { columnDef: 'transactionSuccess',      header: 'Success'                       , cell: ( row: Sofort ) => `${ row.transactionSuccess != null? row.transactionSuccess.toString() : '' }` },
    { columnDef: 'transactionCreatedDate',  header: 'Date of Transaction Creation'  , cell: ( row: Sofort ) => `${ toDateString( row.transactionCreatedDate ) || '' }` },
    { columnDef: 'statementDate',           header: 'Date of Statement'             , cell: ( row: Sofort ) => `${ toDateString( row.statementDate ) || ''          }` },
    { columnDef: 'transactionAmount',       header: 'Transaction Amount'            , cell: ( row: Sofort ) => `${ row.transactionAmount || ''                      }`,getClass:( row: Sofort ) => this.getRowClass(row)},
    { columnDef: 'statementAmount',         header: 'Statement Amount'              , cell: ( row: Sofort ) => `${ row.statementAmount || ''                        }`,getClass:( row: Sofort ) =>  this.getRowClass(row)},
    { columnDef: 'statementUploadDate',     header: 'Statement Upload'              , cell: ( row: Sofort ) => `${ toDateTimeString( row.statementUploadDate ) || ''    }` },
    { columnDef: 'transactionUploadDate',   header: 'Transaction Upload'            , cell: ( row: Sofort ) => `${ toDateTimeString( row.transactionUploadDate ) || ''  }` },
  ];

  onSearch( isInvalid = false ) {
    if ( !isInvalid ) {
      this.table.applyFilter();
    }
  }




  exportSoforts() {
    const idList = this.table.selection.selected.map( d => d.id );
    this.sofortsService
      .export( idList ).subscribe( result => {
        FileHelper.saveFile( result );
          this.changeDetectorRefs.detectChanges();
          this.table.refreshTable();
        } );
  }

  currentUserIsAdmin() {
    return this.roleService.hasRoles('admin');
  }
}
